export default __webpack_public_path__ + "static/media/ragdoll7S.d4a8a37f.webp";